import { useLayoutEffect, useRef, useState } from 'react';

export const useChangedRecently = (value: unknown, recentlyAsInThisManyMillisecondsAgo: number) => {
  const isInitial = useRef(true);
  const [changing, setIsChanging] = useState(false);
  useLayoutEffect(() => {
    if (isInitial.current) {
      isInitial.current = false;
      return;
    }
    setIsChanging(true);
    const timeout = setTimeout(() => {
      setIsChanging(false);
    }, recentlyAsInThisManyMillisecondsAgo);
    return () => clearTimeout(timeout);
  }, [value, setIsChanging, recentlyAsInThisManyMillisecondsAgo]);

  return changing;
};
